import React, { useState, useEffect } from 'react';
import { withTranslation } from '../../../ChildrenContext.js';
import PropTypes from 'prop-types';
import MaskedInput from 'react-input-mask';
import FormGroup from '../../../FormGroup';
import Helper from './Helper';

const PaymentSystem = ({
    errors: propErrors,
    paymentSystem: propPaymentSystem,
    fullName: propFullName,
    onChangeFullName: propOnChangeFullName,
    edrpouIpn: propEdrpouIpn,
    onChangeEdrpouIpn: propOnChangeEdrpouIpn,
    bankName: propBankName,
    onChangeBankName: propOnChangeBankName,
    bankAccount: propBankAccount,
    onChangeBankAccount: propOnChangeBankAccount,
    bic: propBic,
    onChangeBic: propOnChangeBic,
    purposeOfPayment: propPurposeOfPayment,
    onChangePurposeOfPayment: propOnChangePurposeOfPayment,
    iban: propIban,
    onChangeIban: propOnChangeIban,
    cryptoCurrency: propCryptoCurrency,
    onChangeCryptoCurrency: propOnChangeCryptoCurrency,
    cryptoNetwork: propCryptoNetwork,
    onChangeCryptoNetwork: propOnChangeCryptoNetwork,
    cardNumber: propCardNumber,
    onChangeCardNumber: propOnChangeCardNumber,
    description: propDescription,
    onChangeDescription: propOnChangeDescription,
    t
}) => {
    const [state, setState] = useState({
        errors: propErrors
    });

    useEffect(() => {
        setState(prevState => ({
            ...prevState,
            errors: propErrors
        }));
    }, [propErrors]);

    const staticNames = t?.paymentPage?.settingModal || {};

    return (
        <React.Fragment>
            <FullName
                state={state}
                props={{
                    paymentSystem: propPaymentSystem,
                    fullName: propFullName,
                    onChangeFullName: propOnChangeFullName
                }}
                staticNames={staticNames}
            />
            <EdrpouIpn
                state={state}
                props={{
                    paymentSystem: propPaymentSystem,
                    edrpouIpn: propEdrpouIpn,
                    onChangeEdrpouIpn: propOnChangeEdrpouIpn
                }}
                staticNames={staticNames}
            />
            <BankName
                state={state}
                props={{
                    paymentSystem: propPaymentSystem,
                    bankName: propBankName,
                    onChangeBankName: propOnChangeBankName
                }}
                staticNames={staticNames}
            />
            <BankAccount
                state={state}
                props={{
                    paymentSystem: propPaymentSystem,
                    bankAccount: propBankAccount,
                    onChangeBankAccount: propOnChangeBankAccount
                }}
                staticNames={staticNames}
            />
            <Bic
                state={state}
                props={{
                    paymentSystem: propPaymentSystem,
                    bic: propBic,
                    onChangeBic: propOnChangeBic
                }}
                staticNames={staticNames}
            />
            <PurposeOfPayment
                state={state}
                props={{
                    paymentSystem: propPaymentSystem,
                    purposeOfPayment: propPurposeOfPayment,
                    onChangePurposeOfPayment: propOnChangePurposeOfPayment
                }}
                staticNames={staticNames}
            />
            <Iban
                state={state}
                props={{
                    paymentSystem: propPaymentSystem,
                    iban: propIban,
                    onChangeIban: propOnChangeIban
                }}
                staticNames={staticNames}
            />
            <CryptoCurrency
                state={state}
                props={{
                    paymentSystem: propPaymentSystem,
                    cryptoCurrency: propCryptoCurrency,
                    onChangeCryptoCurrency: propOnChangeCryptoCurrency
                }}
                staticNames={staticNames}
            />
            <CryptoNetwork
                state={state}
                props={{
                    paymentSystem: propPaymentSystem,
                    cryptoNetwork: propCryptoNetwork,
                    onChangeCryptoNetwork: propOnChangeCryptoNetwork
                }}
                staticNames={staticNames}
            />
            <CardNumber
                state={state}
                props={{
                    paymentSystem: propPaymentSystem,
                    cardNumber: propCardNumber,
                    onChangeCardNumber: propOnChangeCardNumber
                }}
                staticNames={staticNames}
            />
            <Description
                state={state}
                props={{
                    paymentSystem: propPaymentSystem,
                    description: propDescription,
                    onChangeDescription: propOnChangeDescription
                }}
                staticNames={staticNames}
            />
            <br/>
        </React.Fragment>
    );
};

PaymentSystem.propTypes = {
    errors: PropTypes.object,
    paymentSystem: PropTypes.object,
    fullName: PropTypes.string,
    onChangeFullName: PropTypes.func,
    edrpouIpn: PropTypes.string,
    onChangeEdrpouIpn: PropTypes.func,
    bankName: PropTypes.string,
    onChangeBankName: PropTypes.func,
    bankAccount: PropTypes.string,
    onChangeBankAccount: PropTypes.func,
    bic: PropTypes.string,
    onChangeBic: PropTypes.func,
    purposeOfPayment: PropTypes.string,
    onChangePurposeOfPayment: PropTypes.func,
    iban: PropTypes.string,
    onChangeIban: PropTypes.func,
    cryptoCurrency: PropTypes.string,
    onChangeCryptoCurrency: PropTypes.func,
    cryptoNetwork: PropTypes.string,
    onChangeCryptoNetwork: PropTypes.func,
    cardNumber: PropTypes.string,
    onChangeCardNumber: PropTypes.func,
    description: PropTypes.string,
    onChangeDescription: PropTypes.func,
    t: PropTypes.object
};

PaymentSystem.defaultProps = {
    errors: {},
    paymentSystem: null,
    fullName: '',
    onChangeFullName: () => {},
    edrpouIpn: '',
    onChangeEdrpouIpn: () => {},
    bankName: '',
    onChangeBankName: () => {},
    bankAccount: '',
    onChangeBankAccount: () => {},
    bic: '',
    onChangeBic: () => {},
    purposeOfPayment: '',
    onChangePurposeOfPayment: () => {},
    iban: '',
    onChangeIban: () => {},
    cryptoCurrency: '',
    onChangeCryptoCurrency: () => {},
    cryptoNetwork: '',
    onChangeCryptoNetwork: () => {},
    cardNumber: '',
    onChangeCardNumber: () => {},
    description: '',
    onChangeDescription: () => {}
};

function FullName({state ,props, staticNames}) {
    if(!props.paymentSystem) { return false; }
    let showRequired = false;
    if (props.paymentSystem.reqFields.length) { props.paymentSystem.reqFields.forEach(function(field) { if ('full_name' === field) { showRequired = true; } }); }
    let showNotRequired = false;
    if (props.paymentSystem.notReqFields.length) { props.paymentSystem.notReqFields.forEach(function(field) { if ('full_name' === field) { showNotRequired = true; } }); }
    if (!showRequired && !showNotRequired) { return false; }
    return <FormGroup label={`${staticNames.fullName}`} labelClass={`${showRequired ? "required" : ""}`} errors={state.errors.fullName}><input className="form-control" onChange={props.onChangeFullName} type="text" value={props.fullName} required={showRequired} /></FormGroup>;
}

function EdrpouIpn({state ,props, staticNames}) {
    if(!props.paymentSystem) { return false; }
    let showRequired = false;
    if (props.paymentSystem.reqFields.length) { props.paymentSystem.reqFields.forEach(function(field) { if ('edrpou_ipn' === field) { showRequired = true; } }); }
    let showNotRequired = false;
    if (props.paymentSystem.notReqFields.length) { props.paymentSystem.notReqFields.forEach(function(field) { if ('edrpou_ipn' === field) { showNotRequired = true; } }); }
    if (!showRequired && !showNotRequired) { return false; }
    return <FormGroup label={`${staticNames.edrpouIpn}`} labelClass={`${showRequired ? "required" : ""}`} errors={state.errors.edrpouIpn}><input className="form-control" onChange={props.onChangeEdrpouIpn} type="text" value={props.edrpouIpn} required={showRequired} /></FormGroup>;
}

function BankName({state ,props, staticNames}) {
    if(!props.paymentSystem) { return false; }
    let showRequired = false;
    if (props.paymentSystem.reqFields.length) { props.paymentSystem.reqFields.forEach(function(field) { if ('bank_name' === field) { showRequired = true; } }); }
    let showNotRequired = false;
    if (props.paymentSystem.notReqFields.length) { props.paymentSystem.notReqFields.forEach(function(field) { if ('bank_name' === field) { showNotRequired = true; } }); }
    if (!showRequired && !showNotRequired) { return false; }
    return <FormGroup label={`${staticNames.bankName}`} labelClass={`${showRequired ? "required" : ""}`} errors={state.errors.bankName}><input className="form-control" onChange={props.onChangeBankName} type="text" value={props.bankName} required={showRequired} /></FormGroup>;
}

function BankAccount({state ,props, staticNames}) {
    if(!props.paymentSystem) { return false; }
    let showRequired = false;
    if (props.paymentSystem.reqFields.length) { props.paymentSystem.reqFields.forEach(function(field) { if ('bank_account' === field) { showRequired = true; } }); }
    let showNotRequired = false;
    if (props.paymentSystem.notReqFields.length) { props.paymentSystem.notReqFields.forEach(function(field) { if ('bank_account' === field) { showNotRequired = true; } }); }
    if (!showRequired && !showNotRequired) { return false; }
    return <FormGroup label={`${staticNames.bankAccount}`} labelClass={`${showRequired ? "required" : ""}`} errors={state.errors.bankAccount}><input className="form-control" onChange={props.onChangeBankAccount} type="text" value={props.bankAccount} required={showRequired} /></FormGroup>;
}

function Bic({state ,props, staticNames}) {
    if(!props.paymentSystem) { return false; }
    let showRequired = false;
    if (props.paymentSystem.reqFields.length) { props.paymentSystem.reqFields.forEach(function(field) { if ('bic' === field) { showRequired = true; } }); }
    let showNotRequired = false;
    if (props.paymentSystem.notReqFields.length) { props.paymentSystem.notReqFields.forEach(function(field) { if ('bic' === field) { showNotRequired = true; } }); }
    if (!showRequired && !showNotRequired) { return false; }
    return <FormGroup label={`${staticNames.bic}`} labelClass={`${showRequired ? "required" : ""}`} errors={state.errors.bic}><input className="form-control" onChange={props.onChangeBic} type="text" value={props.bic} required={showRequired} /></FormGroup>;
}

function PurposeOfPayment({state ,props, staticNames}) {
    if(!props.paymentSystem) { return false; }
    let showRequired = false;
    if (props.paymentSystem.reqFields.length) { props.paymentSystem.reqFields.forEach(function(field) { if ('purpose_of_payment' === field) { showRequired = true; } }); }
    let showNotRequired = false;
    if (props.paymentSystem.notReqFields.length) { props.paymentSystem.notReqFields.forEach(function(field) { if ('purpose_of_payment' === field) { showNotRequired = true; } }); }
    if (!showRequired && !showNotRequired) { return false; }
    return <FormGroup label={`${staticNames.purposeOfPayment}`} labelClass={`${showRequired ? "required" : ""}`} errors={state.errors.purposeOfPayment}><input className="form-control" onChange={props.onChangePurposeOfPayment} type="text" value={props.purposeOfPayment} required={showRequired} /></FormGroup>;
}

function Iban({state ,props, staticNames}) {
    if(!props.paymentSystem) { return false; }
    let showRequired = false;
    if (props.paymentSystem.reqFields.length) { props.paymentSystem.reqFields.forEach(function(field) { if ('iban' === field) { showRequired = true; } }); }
    let showNotRequired = false;
    if (props.paymentSystem.notReqFields.length) { props.paymentSystem.notReqFields.forEach(function(field) { if ('iban' === field) { showNotRequired = true; } }); }
    if (!showRequired && !showNotRequired) { return false; }
    return <FormGroup label={`${staticNames.iban}`} labelClass={`${showRequired ? "required" : ""}`} errors={state.errors.iban}><input className="form-control" onChange={props.onChangeIban} type="text" value={props.iban} required={showRequired} /></FormGroup>;
}

function CryptoCurrency({state ,props, staticNames}) {
    if(!props.paymentSystem) { return false; }
    let showRequired = false;
    if (props.paymentSystem.reqFields.length) { props.paymentSystem.reqFields.forEach(function(field) { if ('crypto_currency' === field) { showRequired = true; } }); }
    let showNotRequired = false;
    if (props.paymentSystem.notReqFields.length) { props.paymentSystem.notReqFields.forEach(function(field) { if ('crypto_currency' === field) { showNotRequired = true; } }); }
    if (!showRequired && !showNotRequired) { return false; }
    return <FormGroup label={`${staticNames.cryptoCurrency}`} labelClass={`${showRequired ? "required" : ""}`} errors={state.errors.cryptoCurrency}><input className="form-control" onChange={props.onChangeCryptoCurrency} type="text" value={props.cryptoCurrency} required={showRequired} /></FormGroup>;
}

function CryptoNetwork({state ,props, staticNames}) {
    if(!props.paymentSystem) { return false; }
    let showRequired = false;
    if (props.paymentSystem.reqFields.length) { props.paymentSystem.reqFields.forEach(function(field) { if ('crypto_network' === field) { showRequired = true; } }); }
    let showNotRequired = false;
    if (props.paymentSystem.notReqFields.length) { props.paymentSystem.notReqFields.forEach(function(field) { if ('crypto_network' === field) { showNotRequired = true; } }); }
    if (!showRequired && !showNotRequired) { return false; }
    return <FormGroup label={`${staticNames.cryptoNetwork}`} labelClass={`${showRequired ? "required" : ""}`} errors={state.errors.cryptoNetwork}><input className="form-control" onChange={props.onChangeCryptoNetwork} type="text" value={props.cryptoNetwork} required={showRequired} /></FormGroup>;
}

function CardNumber({state ,props, staticNames}) {
    if(!props.paymentSystem) { return false; }
    let showRequired = false;
    if (props.paymentSystem.reqFields.length) { props.paymentSystem.reqFields.forEach(function(field) { if ('card_number' === field) { showRequired = true; } }); }
    let showNotRequired = false;
    if (props.paymentSystem.notReqFields.length) { props.paymentSystem.notReqFields.forEach(function(field) { if ('card_number' === field) { showNotRequired = true; } }); }
    if (!showRequired && !showNotRequired) { return false; }
    return <FormGroup label={`${staticNames.cardNumber}`} labelClass={`${showRequired ? "required" : ""}`} errors={state.errors.cardNumber}><input className="form-control" value={props.cardNumber} type="text" onChange={props.onChangeCardNumber} required={showRequired} /></FormGroup>;
}

function Description({state ,props, staticNames}) {
    if(!props.paymentSystem) { return false; }
    let showRequired = false;
    if (props.paymentSystem.reqFields.length) { props.paymentSystem.reqFields.forEach(function(field) { if ('description' === field) { showRequired = true; } }); }
    let showNotRequired = false;
    if (props.paymentSystem.notReqFields.length) { props.paymentSystem.notReqFields.forEach(function(field) { if ('description' === field) { showNotRequired = true; } }); }
    if (!showRequired && !showNotRequired) { return false; }
    return <FormGroup label={`${staticNames.description}`} labelClass={`${showRequired ? "required" : ""}`} errors={state.errors.description}><textarea className="form-control" rows={3} onChange={props.onChangeDescription} value={props.description} required={showRequired} /></FormGroup>;
}

export default withTranslation(PaymentSystem);
